// ============================================================================
// ZennaPageHeader.jsx — Shared nav header for Marketplace, Gallery, Profile
// ============================================================================

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ThemeToggle from './ui/ThemeToggle'
import CraftMenu from './ui/CraftMenu'

export default function ZennaPageHeader({ title = '', showBack = true }) {
  const navigate = useNavigate()
  const [showCraftMenu, setShowCraftMenu] = useState(false)

  return (
    <header className="bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 sticky top-0 z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/dashboard')} className="flex items-center gap-2 hover:opacity-80 transition-opacity" title="Dashboard">
            <div className="w-8 h-8 rounded-lg bg-gradient-zenna flex items-center justify-center shadow-md shadow-zenna-violet/20">
              <span className="text-white font-bold text-sm">Z</span>
            </div>
            <span className="text-lg font-display font-bold text-slate-900 dark:text-white">Zenna</span>
          </button>
          {title && (
            <>
              <span className="text-slate-300 dark:text-slate-600">/</span>
              <span className="text-sm font-medium text-slate-600 dark:text-slate-400">{title}</span>
            </>
          )}
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <button onClick={() => navigate('/marketplace')} className="hidden sm:flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">🛒 Marketplace</button>
          <button onClick={() => navigate('/gallery')} className="hidden sm:flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">🎨 Gallery</button>
          <button onClick={() => setShowCraftMenu(true)} className="hidden sm:flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors" title="Browse all crafts">🧵 Crafts</button>
          <button onClick={() => navigate('/workspace')} className="hidden sm:flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">✨ Create</button>
          <ThemeToggle />
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold text-zenna-violet hover:bg-zenna-violet/10 transition-colors border border-zenna-violet/20"
          >
            <span className="text-gradient">Zenna Go</span>
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
          </button>
        </div>
      </div>
      <CraftMenu
        isOpen={showCraftMenu}
        onClose={() => setShowCraftMenu(false)}
        onSelect={(craft) => navigate(`/workspace?startCraft=${encodeURIComponent(craft.key)}`)}
      />
    </header>
  )
}